import React from "react";
import { Link } from "react-router-dom";

const FAQ = () => {
  return (
    <div className="faq-page">
      {/* Breadcrumb Section */}
      <div className="optech-breadcrumb" style={{ backgroundImage: "url(/assets/images/breadcrumb/breadcrumb.png)" }}>
        <div className="container">
          <h1 className="post__title">Frequently Asked Questions</h1>
          <nav className="breadcrumbs">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li aria-current="page">Faqs</li>
            </ul>
          </nav>
        </div>
      </div>

      {/* FAQ Accordion Section */}
      <div className="section accordion-page">
        <div className="container">
          <div className="optech-accordion-column">
            <div className="optech-accordion-wrap mt-0 init-wrap">
              {[
                {
                  q: "What types of documents do you translate?",
                  a: "We translate many documents, including legal contracts, business reports, academic papers, medical records, technical manuals, websites, and more."
                },
                {
                  q: "How do you ensure translation accuracy?",
                  a: "All translations are performed by certified, native-speaking linguists and undergo a rigorous QA process, including proofreading and editing."
                },
                {
                  q: "Do you offer certified translations?",
                  a: "Yes, we provide certified and notarized translations accepted by government agencies and legal institutions."
                },
                {
                  q: "How long does it take to complete a translation?",
                  a: "Turnaround time depends on the document’s complexity. We also accommodate urgent or same-day requests."
                },
                {
                  q: "Can you handle multiple languages in one project?",
                  a: "Absolutely. We manage multi-language projects while ensuring consistency and quality across all versions."
                },
                {
                  q: "Is my information kept confidential?",
                  a: "Yes. We follow strict confidentiality protocols and can sign NDAs upon request."
                },
                {
                  q: "What is localization, and how is it different from translation?",
                  a: "Localization adapts content culturally and regionally. Translation is literal, while localization is context-sensitive."
                },
                {
                  q: "How do I request a quote or start a project?",
                  a: "You can contact us through our website, email, or phone. We’ll respond promptly with a custom quote."
                }
              ].map((item, index) => (
                <div key={index} className={`optech-accordion-item ${index === 0 ? 'open' : ''}`}>
                  <div className="optech-accordion-header init-header">
                    <h5><span>Q{index + 1}.</span> {item.q}</h5>
                  </div>
                  <div className="optech-accordion-body init-body">
                    <p>{item.a}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Still have a question */}
      <div className="section optech-section-padding-bottom">
        <div className="container">
          <div className="optech-default-content sm-mw">
            <h2>Still, Have a Question?</h2>
            <p>
              If you have a specific question that hasn’t been addressed in our FAQs, we’re here to help. Contact us via the form, email
              <a href="mailto:support@ra-inc.com"> support@ra-inc.com </a>
              or call us at <a href="tel:(516) 208-3462">(516) 208-3462</a>.
            </p>
            <div className="optech-extra-mt" data-aos="fade-up" data-aos-duration="800">
              <Link className='optech-default-btn optech-light-btn' data-text='Ask Any Question' to='/contact-us'>
                <span className="btn-wraper">Ask Any Question</span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="section bg-cover optech-section-padding" style={{ backgroundImage: "url(/assets/images/cta/cta-bg2.png)" }}>
        <div className="container">
          <div className="optech-cta-wrap">
            <div className="optech-cta-content center">
              <h2>Let's Translate Your Vision Into Every Language</h2>
              <p>
                Whether you're expanding internationally or need multilingual content locally,
                we tailor solutions to your audience and goals.
              </p>
              <div className="optech-extra-mt" data-aos="fade-up" data-aos-duration="800">
                <Link className='optech-default-btn' data-text='Let’s Start a Project' to='/contact-us'>
                  <span className="btn-wraper">Let’s Start a Project</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;